import api from '@/core/apiclient'
import {actionTypes} from '@/core/constants'

export default {

    async [actionTypes.RELATORIOS.GERAR_RELATORIO_FICHA_PACIENTE](context, dados) {
        await api.relatorios.gerarRelatorioFichaPaciente(dados)
    },

    async [actionTypes.RELATORIOS.GERAR_RELATORIO_COBRANCA](context, dados) {
        await api.relatorios.gerarRelatorioCobranca(dados)
    },

    async [actionTypes.RELATORIOS.GERAR_RELATORIO_PACIENTES](context, dados) {
        await api.relatorios.gerarRelatorioPacientes(dados)
    },

    async [actionTypes.RELATORIOS.GERAR_RELATORIO_ORCAMENTOS](context, dados) {
        const {data} = await api.relatorios.gerarRelatorioOrcamentos(dados)
        return data
    },

    async [actionTypes.RELATORIOS.GERAR_RELATORIO_PAGAMENTOS](context, dados) {
        await api.relatorios.gerarRelatorioPagamento(dados)
    },

    async [actionTypes.RELATORIOS.GERAR_RELATORIO_ORCAMENTO_FINALIZADO](context, dados) {
        await api.relatorios.gerarRelatorioOrcamentoFinalizado(dados)
    },

}